import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { SiteShell } from './components/SiteShell';
import HomePage from './pages/HomePage';
import HowItWorksPage from './pages/HowItWorksPage';
import ForAgentsPage from './pages/ForAgentsPage';
import ForNodesPage from './pages/ForNodesPage';
import ContractsPage from './pages/ContractsPage';
import EconomyPage from './pages/EconomyPage';

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace(/^#/, '');
      const timer = window.setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 80);
      return () => window.clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);
  return null;
}

function PageMeta({ title, description }: { title: string; description: string }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <SiteShell>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <PageMeta
                    title="Essence — Stablecoin on Base | Self Labs"
                    description="Essence is Self Labs / Role Model’s Base ERC-20 stablecoin — node rewards, agent payments for goods and services, and a treasury rail toward USDC."
                  />
                  <HomePage />
                </>
              }
            />
            <Route
              path="/how-it-works"
              element={
                <>
                  <PageMeta
                    title="How Essence works — Stripe → treasury → nodes & agents"
                    description="AI companies buy Resonatia inference (API keys / hosting); that spend funds Essence for nodes and agent settlement on Base."
                  />
                  <HowItWorksPage />
                </>
              }
            />
            <Route
              path="/economy"
              element={
                <>
                  <PageMeta
                    title="Essence — Economic layer of SELF OS"
                    description="Essence is SELF OS’s economic layer for agents, compute rewards, and settlement — beyond payments alone. Live rails vs platform direction clearly separated."
                  />
                  <EconomyPage />
                </>
              }
            />
            <Route
              path="/for-agents"
              element={
                <>
                  <PageMeta
                    title="Essence for AI agents — pay for goods & services on Base"
                    description="Agents transfer and settle Essence on Base for goods, services, and agent-to-agent payments. Hold or exit toward USDC via treasury."
                  />
                  <ForAgentsPage />
                </>
              }
            />
            <Route
              path="/for-nodes"
              element={
                <>
                  <PageMeta
                    title="Essence for Self OS nodes — idle compute rewards"
                    description="Idle phone compute earns Essence on a cloud ledger. Talk credits live in Self Shell beta; on-chain withdraw next."
                  />
                  <ForNodesPage />
                </>
              }
            />
            <Route
              path="/contracts"
              element={
                <>
                  <PageMeta
                    title="Essence contracts on Base — token, treasury, bridge"
                    description="Live Base mainnet addresses for ESSENCE, EssenceTreasury, and EssenceBridge — with Basescan links."
                  />
                  <ContractsPage />
                </>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </SiteShell>
      </Router>
    </HelmetProvider>
  );
}
